import {
  DEFAULT_DATETIME_DAY_FORMAT,
  formatDateTimeFromMillis
} from "../../../../../utils"

interface Props {
  timestamp?: number
}

const QuoteDate = ({ timestamp }: Props) => {
  return (
    <time
      {...(timestamp ? { dateTime: new Date(timestamp)?.toISOString() } : {})}
      className="font-bold text-lg pb-4"
    >
      {timestamp
        ? formatDateTimeFromMillis(
            timestamp * 1000,
            DEFAULT_DATETIME_DAY_FORMAT
          )
        : "Unknown date"}
    </time>
  )
}

export default QuoteDate
